import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/PoolActions";
import * as api from "../../api/PoolApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();
        yield put(actions.setAreaList(data || undefined));
    } catch (error) {
        yield put(actions.setAreaList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMaintenanceTypeList(action) {
    try {
        const { data } = yield api.getMaintenanceTypeList(action.payload);
        yield put(actions.setMaintenanceTypeList(data || undefined));
    } catch (error) {
        yield put(actions.setMaintenanceTypeList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownReasonGroupList() {
    try {
        const { data } = yield api.getBreakDownReasonGroupList();
        yield put(actions.setBreakDownReasonGroupList(data || undefined));
    } catch (error) {
        yield put(actions.setBreakDownReasonGroupList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPoolById(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getPoolById(action.payload);
        yield put(actions.setPoolById(data || undefined));
    } catch (error) {
        yield put(actions.setPoolById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPoolRelationById(action) {
    try {
        const { data } = yield api.getPoolRelationById(action.payload);
        yield put(actions.setPoolRelationById(data || undefined));
    } catch (error) {
        yield put(actions.setPoolRelationById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* editPoolRelation(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.editPoolRelation(action.payload);
        yield put(actions.setEditPoolRelationResponse(data || undefined));
        yield put(actions.resetEditPoolRelation());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.setEditPoolRelationResponse(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownReasonPlaceData() {
    try {
        const { data } = yield api.getBreakdownReasonPlaceData();
        yield put(actions.setBreakdownReasonPlaceData(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_POOL_RELATION_BY_ID, getPoolRelationById);
    yield takeEvery(actions.Types.GET_AREA_FOR_POOL, getAreaList);
    yield takeEvery(actions.Types.GET_MAINTENANCE_TYPE_LIST, getMaintenanceTypeList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_GROUP_LIST_FOR_POOL, getBreakDownReasonGroupList);
    yield takeEvery(actions.Types.GET_POOL_BY_ID, getPoolById);
    yield takeEvery(actions.Types.EDIT_POOL_RELATION, editPoolRelation);
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASON_PLACE_DATA, getBreakDownReasonPlaceData);
}

const poolSaga = [fork(watchAll)];

export default poolSaga;
